import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import { Redirect } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import { Link } from 'react-router-dom'
import { getList } from '../../store/actions/listActions'
import Loader from '../../components/custom/loader'
import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment'
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';

class Users extends Component {

  render() {
    const { users, auth, loading, profile } = this.props

    if (!users) {
      return <Loader />
    }

    if (!auth.uid) return <Redirect to='/signin' />

    console.log("users : ", users)

    return (
      <div style={{ width: '90%', margin: 'auto', maxWidth: 1000, marginTop:20 }}>
        <Typography style={{marginLeft:10}} variant="h4">Users</Typography>
        <Link to={'/create-user'}>
          <Button
            style={{ float: 'right', margin: '10px 2px -10px 0' }}
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
          >Add New User </Button></Link>
        <div style={{ clear: 'both', height: 1, width: '100%' }}></div>
        {
          users ?
            users.length ?

              <TableContainer style={{ marginTop: 20, marginBottom: 20 }} component={Paper}>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Code</TableCell>
                      <TableCell>Designation</TableCell>
                      <TableCell>Role</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Mobile No</TableCell>


                      {/* <TableCell align="right">Updated At</TableCell>
                      <TableCell align="right">Created At</TableCell> */}
                      <TableCell align="right">Edit</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>

                    {users.map((user) => {
                      return (
                        <TableRow key={user.id}>
                          <TableCell>{user.displayName}</TableCell>
                          <TableCell>{user.employeeCode}</TableCell>
                          <TableCell>{user.designation}</TableCell>
                          <TableCell>{user.role}</TableCell>
                          <TableCell>{user.email}</TableCell>
                          <TableCell>{user.phoneNumber}</TableCell>

                          {/* <TableCell align="right">{user.updatedAt ? moment(user.updatedAt.toDate()).calendar() : moment(user.createdAt.toDate()).calendar()}</TableCell>
                          <TableCell align="right">{moment(user.createdAt.toDate()).calendar()}</TableCell> */}
                          <TableCell align="right">
                            {
                              (user.role != 'Admin')
                              &&
                              <Link to={'/edit-user/'+user.id}>
                                <IconButton>
                                  <EditIcon />
                                </IconButton>
                              </Link>
                            }
                            
                          </TableCell>

                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>

              : <Typography variant="h5">There are no user(s) to show</Typography>
            : null
        }
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getList: (listName, con) => dispatch(getList(listName, con))
  }
}

const mapStateToProps = (state) => {

  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    users: state.firestore.ordered.users,
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => {
    if (props.profile.role == 'SuperAdmin')
    return [
        {
          collection: 'users',
          where: ['role', '==', 'Admin']
        }
      ]
    else
      return [
        {
          collection: 'users',
          where: ['organization.id', '==', props.profile.organization && props.profile.organization.id || 'Jassu']
        }
      ]
  })
)(Users)
